import { useEffect, useMemo, useState } from "react"
import { bool, string, number, func } from 'prop-types';

import { Loading, Modal, TableCustom } from "../"
import InputTipoMultaFilters from "./components/InputTipoMultaFilters"
import { getTipoMultas } from "../../controls/MultasGrid/utils";

import './index.css'

const InputTipoMulta = (props) => {
    const [data, setData] = useState([])
    const [filters, setFilters] = useState({})
    const [loading, setLoading] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [nombres, setNombres] = useState({})
    const [showTableData, setShowTableData] = useState(false)

    const filteredData = useMemo(() => {
        return data.filter(x => (
            (!x.idTipoTributo || x.idTipoTributo === props.idTipoTributo)
            && (!filters.nombre ||  x.nombre.toLowerCase().includes(filters.nombre.toLowerCase()))
            && (!filters.codigo || x.codigo.toLowerCase().includes(filters.codigo.toLowerCase()))
        ))
    }, [data, filters])

    useEffect(() => {
        setLoading(true)
        getTipoMultas({
            onSuccess: setData,
            onDone: () => setLoading(false),
        })
    }, [])

    useEffect(() => {
        if (nombres[props.value] === undefined) {
            setNombres(prev => ({ ...prev, [props.value]: data.find(x => x.id === props.value)?.nombre}))
        }
    }, [data, props.value])

    const onSearch = (newFilters) => {
        setFilters(newFilters)
        setShowTableData(true)
    }

    const onSelection = ({ original }) => {
        setShowModal(false)

        if (props.onChange) props.onChange({
            target: {
                name: props.name,
                type: 'entidad',
                value: original.id,
                row: original,
            }
        })
    }

    const onNoSelection = () => {
        setShowModal(false)

        if (props.onChange) props.onChange({
            target: {
                name: props.name,
                type: 'entidad',
                value: 0,
                row: null,
            }
        })
    }

    const onCancel = () => {
        setShowModal(false)
    }

    const cellS = ({ row }) => (
        <div className='action'>
            <div onClick={ (event) => { onSelection(row) }} className="link">
            <span className="material-symbols-outlined" title="Seleccionar">west</span>
            </div>
        </div>
    )

    return <>
        <input
            name={props.name || "idTipoMulta"}
            type="text"
            placeholder={props.placeholder}
            className={"input-tipo-multa form-control" + (props.className ? ` ${props.className}` : '')}
            value={nombres[props.value] ?? ''}
            onClick={() => setShowModal(true)}
            onKeyDown={(e) => { if (e.key === 'Enter') setShowModal(true); }}
            readOnly
            disabled={props.disabled}
        />

        <Loading visible={loading} />

        <Modal
            onEscape={onCancel}
            show={showModal}
            title="Tipo de multa"
            body={<>
                <InputTipoMultaFilters {...{onSearch}} idTipoTributo={props.idTipoTributo} />

                <TableCustom
                    className="TableCustomBase"
                    data={showTableData ? filteredData : []}
                    columns={[
                        { Header: '', Cell: cellS, id:'select', accessor: 'id', width: '5%', disableGlobalFilter: true, disableSortBy: true },
                        { Header: 'Nombre', accessor: 'nombre', width: '50%', },
                        { Header: 'Código', accessor: 'codigo', width: '50%', },
                    ]}
                    onClickRow={onSelection}
                    showFilterGlobal={false}
                    showDownloadCSV={false} 
                />
            </>}
            footer={(
                <div className='footer-action-container'>
                    <button className="btn btn-outline-primary float-end" data-dismiss="modal" onClick={onNoSelection}>Sin selección</button>
                    <button className="btn back-button float-start" data-dismiss="modal" onClick={onCancel}>Volver</button>
                </div>
            )}
        />
    </>
}

InputTipoMulta.propTypes = {
    name: string,
    placeholder: string,
    className: string,
    value: number,
    idTipoTributo: number,
    onChange: func,
    disabled: bool,
};

InputTipoMulta.defaultProps = {
    name: "idTipoMulta",
    placeholder: "",
    className: "",
    value: null,
    idTipoTributo: null,
    onChange: null,
    disabled: false,
};

export default InputTipoMulta
